import { useState } from "react";
import { Icon } from "src/components";

export interface Props {
  onSearchInput: (value: string) => void;
  hasFilter?: boolean;
  placeholder: string;
  filterToggle?: (value: boolean) => void;
}

const TableSearch = (props: Props) => {
  const [isFilterOn, setFilterOn] = useState(true);
  const handleFilterInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.onSearchInput(e.target.value);
  };

  const toggleFilter = () => {
    setFilterOn(!isFilterOn);
    if (props.filterToggle) {
      props.filterToggle(isFilterOn);
    }
  };

  return (
    <div data-testid="table-search">
      <div className="flex searchbar-container items-center">
        <div className="input-container">
          <div className="icon-holder-search">
            <Icon name="magnifying-glass" className="fill-gray-400" />
          </div>
          <input
            data-testid="table-search-input"
            className="input"
            type="text"
            placeholder={props.placeholder}
            onChange={handleFilterInput}
          />
        </div>
        {props.hasFilter && (
          <div className="searchbar-filter" onClick={toggleFilter}>
            <div className={`icon-holder ${!isFilterOn ? "toggled" : ""}`}>
              <Icon name="filter" data-testid="table-search-filter-logo" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TableSearch;
